import { TipoAplicacao, TipoCampoPersonalizado } from './enum';
import { CampoPersonalizadoItem } from './campo-personalizado-item';

export class CampoPersonalizado {
  id: number;
  descricao: string;
  tipo: TipoCampoPersonalizado;
  itens: CampoPersonalizadoItem[];
  tipoAplicacao: TipoAplicacao;
  qtdLinhas: number;
  adicionavel: boolean;
  respObg: boolean;
  categorias: number[];
}
